import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2082c28"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "me-4 d-flex align-center"
}
const _hoisted_3 = {
  key: 1,
  class: "ms-4 d-flex align-center"
}

import { withDefaults, computed } from 'vue';

interface IProps {
  text?: string;
  background?: string;
  prependIcon?: boolean;
  outlined?: boolean;
  appendIcon?: boolean;
  disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomButton',
  props: {
    text: null,
    background: null,
    prependIcon: { type: Boolean },
    outlined: { type: Boolean },
    appendIcon: { type: Boolean },
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { text?: string, background?: string, prependIcon?: boolean, outlined?: boolean, appendIcon?: boolean, disabled: boolean };



const backgroundColor = computed(() => {
  return props.background ? props.background : 'primary';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: __props.disabled,
    class: _normalizeClass([[`bg-${_unref(backgroundColor)}`, __props.outlined ? 'btn-outlined' : ''], "d-flex align-center"])
  }, [
    (__props.prependIcon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "prependIcon")
        ]))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(__props.text) + " ", 1),
    _renderSlot(_ctx.$slots, "default"),
    (__props.appendIcon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "appendIcon")
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})